/*
Error codes
60 = Bootloader

*/
export const INFO_ERROR_CODES = [60];

export const isInfoError = (errorId) =>
    INFO_ERROR_CODES.includes(errorId);

export const hasOnlyInfoErrors = (deviceStatus) => {
    const realErrors = deviceStatus?.errors?.filter(e => e.type === "error") ?? [];

    return (
        realErrors.length > 0 &&
        realErrors.every(e => isInfoError(e.id))
    );
};